import React, { Suspense } from 'react';
import { PermissionsType } from '@/common/permissionsConst';
import { Themes } from '@maxtropy/components';

const GenerationDispatchCenter = React.lazy(() => import('./index'));

const routes = [
  {
    path: '/dispatch/control/generation-center',
    permission: PermissionsType.P_POWER_DISPATCH_CENTER,
    theme: Themes.DARK,
    element: (
      <Suspense fallback={null}>
        <GenerationDispatchCenter />
      </Suspense>
    ),
  },
];

export default routes;
